<template>
  <el-form :model="form" :rules="getrules" ref="ruleForm" label-width="120px" :validate-on-rule-change="false">
    <el-form-item label="品牌logo" prop="logo">
      <el-upload class="ads-avatar-uploader" action="#" :show-file-list="false" :http-request="handleUpload">
        <div v-loading="upload_loading">
          <img v-if="form.logo" :src="form.logo" class="ads-avatar">
          <i v-else class="el-icon-plus ads-avatar-uploader-icon"></i>
        </div>
      </el-upload>
      <p style="font-size: 12px;color: #999;margin-top: 10px;">比例：1 ：1，格式：png、jpg、jpeg，最大不超过：1MB</p>
    </el-form-item>
    <el-form-item label="标题" prop="title_name">
      <el-input v-model="form.title_name" placeholder="请输入标题" :maxlength="title_max_length" show-word-limit></el-input>
    </el-form-item>
    <el-form-item label="品牌名称" prop="corporate">
      <el-input v-model="form.corporate" placeholder="请输入品牌名称" :maxlength="corporate_max_length" show-word-limit></el-input>
    </el-form-item>
    <el-form-item label="按钮文案" prop="ad_button_text">
      <el-input v-model="form.ad_button_text" placeholder="请输入按钮文案" maxlength="128" show-word-limit></el-input>
    </el-form-item>
    <!-- <el-form-item label="是否预装" prop="install_pkg_type">
      <el-radio-group v-model="form.install_pkg_type">
        <el-radio label="0">非预装 </el-radio>
        <el-radio label="1">预装</el-radio>
      </el-radio-group>
    </el-form-item> -->
    <!-- <el-form-item label="匹配方式" prop="match_type">
      <el-radio-group v-model="form.match_type">
        <el-radio label="0">精准匹配</el-radio>
        <el-radio label="1">宽泛匹配</el-radio>
      </el-radio-group>
    </el-form-item> -->
    <el-form-item label="应用包类型" prop="pkg_src">
      <el-checkbox true-label="2" false-label="" v-model="form.pkg_src">荣耀商店包</el-checkbox>
    </el-form-item>
    <el-form-item label="智能分包渠道号" prop="itg_sct_id">
      <el-row>
        <el-col :span="20">
          <ESelect v-model="form.itg_sct_id" placeholder="请选择渠道包ID" filterable remote :remote-method="remoteMethodPkg"
            :loading="channel_pkg_number_loading" style="width: 100%;" clearable>
            <el-option v-for="item in channel_pkg_number_list" :key="item.value" :label="item.label"
              :value="item.value">
            </el-option>
          </ESelect>
        </el-col>
        <el-col :span="4" style="padding-left: 10px;">
          <!-- <el-button type="primary" @click="handleUpdatePkg" :disabled="industry_disabled">更新{{ industry_disabled ?
            industry_countdown : null }}</el-button> -->
          <Countdown @click="handleUpdatePkg" />
        </el-col>
      </el-row>

    </el-form-item>
    <el-form-item label="创意行业" prop="industry_l">
      <!-- :props="{emitPath:false}" -->
      <el-cascader v-model="form.industry_l" :options="industry_list" placeholder="请输入创意行业" style="width: 100%;"
        popper-class="ads_industry_list_popper cascader-x-scroll-auto" clearable></el-cascader>
    </el-form-item>
    <!-- <el-form-item label="创意标签" prop="industry_labels">
      <el-select v-model="form.industry_labels" multiple placeholder="请输入创意标签" style="width: 100%;">
        <el-option v-for="item in industry_labels_list" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </el-form-item> -->
    <!-- LANDING_PAGE_TYPE_USER_DEFINED 商店应用详情页 LANDING_PAGE_TYPE_APP 落地页 -->
    <el-form-item label="落地页链接" prop="landing_page_type">
      <el-radio-group v-model="form.landing_page_type">
        <el-radio label="0">商店应用详情页</el-radio>
        <el-radio label="1">落地页</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="落地页" prop="landing_page_2" v-if="form.landing_page_type == '1'">
      <el-row>
        <el-col :span="20">
          <ESelect v-model="form.landing_page_2" placeholder="请选择落地页" style="width: 100%;">
            <el-option :label="item.label" :value="item.value" v-for="(item, index) in venus_list" :key="index">
              <!-- <div>
                <el-tooltip effect="dark" placement="right-start">
                  <div slot="content">
                    <img :src="item.url" style="width: 100px;height: 180px; object-fit: cover;">
                  </div>
                  <div>{{ item.label }}</div>
                </el-tooltip>
              </div> -->
            </el-option>
          </ESelect>
        </el-col>
        <el-col :span="4" style="padding-left: 10px;">
          <Countdown @click="handleUpdateVenus" />
        </el-col>
      </el-row>
    </el-form-item>

    <el-form-item label="监测对接方式" prop="monitor_docking_mode">
      <el-radio-group v-model="form.monitor_docking_mode">
        <el-radio label="1">客户端对接C2S(建议)</el-radio>
        <el-radio label="2">服务端对接S2S</el-radio>
      </el-radio-group>
    </el-form-item>

    <el-form-item prop="impression_url">
      <template #label>
        曝光监测链接
        <!-- <el-tooltip effect="dark" placement="top-start">
          <div slot="content" style="max-height: 40vh;overflow-y: auto;">
            <div>曝光监测链接的前缀必须是一下url：</div>
            <div v-html="unHttpHtml"></div>
          </div>
          <i class="el-icon-question" style="cursor: pointer;" />
        </el-tooltip> -->
      </template>
      <el-input v-model="form.impression_url" placeholder="请输入曝光监测链接"></el-input>
    </el-form-item>
    <el-form-item prop="click_url">
      <template #label>
        点击监测链接
        <!-- <el-tooltip effect="dark" placement="top-start">
          <div slot="content" style="max-height: 40vh;overflow-y: auto;">
            <div>监测地址的前缀必须是一下url：</div>
            <div v-html="unHttpHtml"></div>
          </div>
          <i class="el-icon-question" style="cursor: pointer;" />
        </el-tooltip> -->
      </template>
      <el-input v-model="form.click_url" placeholder="请输入点击监测链接"></el-input>
    </el-form-item>

    <el-form-item label="产品包名" prop="package_name" v-if="rootFormData.promotion_purpose == '2'">
      <el-input v-model="form.package_name" placeholder="请输入产品包名"></el-input>
    </el-form-item>
    <el-form-item label="deeplink链接" prop="deep_link_url" v-if="rootFormData.product_type == '2'">
      <el-input v-model="form.deep_link_url" placeholder="请输入deeplink链接"></el-input>
    </el-form-item>
    <el-form-item label="H5链接" prop="h5_url" v-if="rootFormData.product_type == '2'">
      <el-input v-model="form.h5_url" placeholder="请输入H5链接"></el-input>
    </el-form-item>

  </el-form>
</template>
<script>
import _ from 'lodash'
import Countdown from '@/views/marketingManagement/configuration/components/countdown.vue'
import Honor from '@/libs/cos/Honor.js'
import getMediaInfo from '@/libs/media';
import { unHttp } from './unHttp.js'
import {
  BatchIntelligentPackageListApi,
  BatchIntelligentPackageListUpdateApi,
} from '@/api/marketManage/configuration.js'
import { postBatchPromotionVenusUpdateApi } from '@/api/marketManage/huaweiAds.js'
export default {
  name: 'FormGroup',// 'fill', 'contain', 'cover', 'none', 'scale-down'
  components: {
    Countdown
  },
  props: {
    rootFormData: {
      type: Object,
      default: () => { }
    },
    product: {
      type: [String, Number],
    },
    industry_list: {
      type: Array,
      default: () => []
    },
    venus_list: {
      type: Array,
      default: () => []
    },
    value: {
      type: Object,
      default: () => ({})
    },
    rules: {
      type: Object,
      default: () => ({})
    },
    title_max_length: {
      type: Number,
      default: 100
    },
    corporate_max_length: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {
      unHttp: unHttp,
      upload_loading: false,
      package_loading: false,
      package_list: [],
      channel_pkg_number_loading: false,
      channel_pkg_number_list: [],
      industry_labels_list: [],
      package_disabled: false,
      package_countdown: 120,
      industry_disabled: false,
      industry_countdown: 120,
    }
  },
  computed: {
    form: {
      get() {
        return this.value
      }
    },
    getrules() {
      return this.$props.rules
    },
    unHttpHtml() {
      let html = this.unHttp.join('<br/>')
      return `<div>${html}</div>`
    }
  },
  watch: {
    'form.landing_page_type': {
      handler(newval) {
        this.$set(this.form, 'landing_page_1', '')
        // if (newval == '0') {
        //   this.$set(this.form, 'landing_page_1', 'market://details?id=__ID__&appName=__APP_NAME__&caller=__CALLER__&request_id=__REQID__')
        // } else {
        // }
      },
      immediate: true
    },
    'product': {
      handler(newval) {
        if (!newval) return
        if (!newval?.itg_sct_id) {
          this.remoteMethodPkg('')
        } else {
          this.remoteMethodPkg(newval?.itg_sct_id)
        }
      },
      immediate: true
    },
    'form.industry_l': {
      handler(newval) {
        if (!newval || newval.length == 0) {
          this.industry_labels_list = []
          this.form.industry_labels = []
        }
      },
      deep: true
    }
  },
  created() {
    this.resetForm()
  },
  methods: {
    remoteMethodPkg: _.throttle(async function (query) {
      // if (!query) {
      //   this.channel_pkg_number_list = [];
      //   return;
      // }
      try {
        let res = await BatchIntelligentPackageListApi({
          plat_id: 11,
          account_id: this.rootFormData.account_id,
          app_id: this.product,
          search: query
        })
        this.channel_pkg_number_list = res.data.list
      } catch (error) {
        this.$message.error(error.info)
      }
    }, 300),
    handleUpdateVenus() {
      this.$notify({
        type: 'success',
        title: '提示',
        message: '请求成功',
      })
      postBatchPromotionVenusUpdateApi({
        account_id: this.rootFormData.account_id,
        plat_id: 11,
      }).then(res => {
        this.$emit('updateFetch', 'venus_list')
        this.$notify.closeAll()
        this.$notify({
          type: 'success',
          title: '提示',
          message: '更新成功',
        })
      }).catch(err => {
        this.$notify.closeAll()
        this.$notify({
          type: 'error',
          title: '更新失败',
          message: err.info,
        })
      })
    },
    handleUpdatePkg() {
      this.$notify({
        type: 'success',
        title: '提示',
        message: '请求成功',
      })
      BatchIntelligentPackageListUpdateApi({
        account_id: this.rootFormData.account_id,
        plat_id: 11,
      }).then(res => {
        this.$notify.closeAll()
        this.$notify({
          type: 'success',
          title: '提示',
          message: '更新成功',
        })
      }).catch(err => {
        this.$notify.closeAll()
        this.$notify({
          type: 'error',
          title: '更新失败',
          message: err.info,
        })
      })
    },
    findItemByValue(arr, value) {
      // 遍历每个项，递归查找
      for (let item of arr) {
        // 如果当前项匹配
        if (item.value === value) {
          return item; // 返回当前项
        }
        // 如果有 children，则递归查找
        if (item.children) {
          const found = this.findItemByValue(item.children, value);
          if (found) return found; // 找到匹配的子项
        }
      }
      return null; // 没有找到则返回 null
    },
    async handleUpload({ file }) {
      // 上传前校验文件
      const media = await getMediaInfo(file);
      const { format, fileSize, height, width } = media;
      // 添加验证逻辑
      const maxSize = 1 * 1024 * 1024;  // 1MB
      const validFormats = ['png', 'jpg', 'jpeg'];
       let file_name = file.name
      const index = file_name.lastIndexOf('.')
      let suffix = file_name.substring(index + 1);
      if (!validFormats.includes(suffix.toLowerCase())) {
        this.$message.error('文件格式必须为 png、jpg 或 jpeg');
        return;
      }

      if (fileSize > maxSize) {
        this.$message.error('文件大小不能超过 1MB');
        return;
      }

      if (width / height != 1) {
        this.$message.error('图片比例必须为 1 ：1。');
        return;
      }
      this.upload_loading = true
      const result = await Honor.putObject(file);
      if (result?.statusCode == 200) {
        let location = result.full_path
        this.form.logo = location;
      }
      this.upload_loading = false
    },
    submitForm: async function () {
      try {
        console.log('this.$refs.ruleForm', this.$refs.ruleForm)
        let result = await this.$refs.ruleForm.validate();
        return Promise.resolve(this.form)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    resetForm() {
      this.$refs?.ruleForm?.clearValidate();
    }
  }
}
</script>
<style>
.ads-avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.ads-avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.ads-avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 108px;
  height: 108px;
  line-height: 108px;
  text-align: center;
}

.ads-avatar {
  width: 108px;
  height: 108px;
  display: block;
}

.ads_industry_list_popper .el-cascader-panel {
  max-height: 360px;
  min-height: 100px;
  /* 设置最大高度，根据需要调整 */
}
</style>
